// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner[data-v-29b2e33f]{display:block}.banner[data-v-29b2e33f] code{padding:0 3px;margin:0 3px}", ""]);
// Exports
module.exports = exports;
